export default __webpack_public_path__ + "static/media/25.464557b8.jpg";